// @flow
import './Popup.css';

import * as React from 'react';
import _ from 'lodash';
import Portal from './../common/Portal';
import PopupTriangle from './PopupTriangle';
import { debuglog } from 'util';

const debug = require('../debug/debug')('wc:common:Popup');

type Props = {
  children: any,
  onClose: Function,
  style: Object,
  top?: boolean,
  right?: boolean,
  bottom?: boolean,
  left?: boolean
};

export default class Popup extends React.Component<Props, {}> {
  closed: boolean;
  onBackgroundClick = (e: MouseEvent) => {
    if (this.props.children.props.name === 'TimelinePopup') e.stopPropagation();

    if (e.target === e.currentTarget) {
      this.onClose();
    }
  };

  componentWillUnmount() {
    this.onClose();
  }

  onClose = () => {
    if (!this.closed) {
      this.closed = true;
      if (_.isFunction(this.props.onClose)) {
        this.props.onClose();
        if (debug.enabled) {
          debug('[onClose()] this.props.onClose called.');
        }
      }
    }
  };

  onOpen = () => {
    this.closed = false;
    if (debug.enabled) {
      debug('[onOpen] Popup Opened');
    }
  };

  render() {
    const { children, style, onClose, ...rest } = this.props;
    return (
      <Portal defaultOpen={true} closeOnEsc={true} closeOnOutsideClick={true} onClose={this.onClose}>
        <div
          className={this.props.styleClass ? this.props.styleClass : 'transparent-background'}
          onClick={this.onBackgroundClick}>
          <div name="Popup" style={style}>
            <div className="content">{children}</div>
            <PopupTriangle {...rest} />
          </div>
        </div>
      </Portal>
    );
  }
}
